import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { MetaTagService } from 'src/app/shared/services/MetaTagService/meta-tag.service';

@Component({
  selector: 'app-products-page',
  templateUrl: './products-page.component.html',
  styleUrls: ['./products-page.component.css'],
})
export class ProductsPageComponent implements OnInit, OnDestroy {
  productsCategories: any[] = [];
  language!: string;
  routeSub!: Subscription;
  selectedTab: string = '';
  constructor(
    private route: ActivatedRoute,
    private metaTagService: MetaTagService
  ) {}

  ngOnInit(): void {
    this.language = this.route.snapshot.url[0].path;

    this.routeSub = this.route.params.subscribe((params) => {
      if (params['lang']) {
        this.language = params['lang'];
        this.getResolverData();
      }
    });
    this.getResolverData();
  }

  getResolverData() {
    console.log(this.route.snapshot.data);
    const resolverData = this.route.snapshot.data['serviceData'];

    if (resolverData) {
      this.productsCategories = resolverData.productComponents;
      console.log(this.productsCategories);
      this.metaTagService.updateMetaTags(resolverData.metadata.meta);
    } else {
      console.error('Resolver data is undefined');
    }
  }
  onTabChange(tab: any) {
    console.log(tab);
    this.selectedTab = tab;
  }
  ngOnDestroy(): void {
    if (this.routeSub) {
      this.routeSub.unsubscribe();
    }
  }
}
